import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import BasicMenu from '../../layouts/dashboard/nav/submenuslide'
// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other} style={{ display : 'flex', background:'none'}}>
      <List disablePadding sx={{ p: 1 }} style={{ display : 'flex',}}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
    
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: '#1A9EF8',
          fontWeight: '600',
        },
      }}
    >

      <ListItemText disableTypography primary={title} sx={{ padding : '20px', fontSize:'1.2rem', }}/>

      {info && info}
    </StyledNavItem>
  );
}
